import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

export type AddNewSessionCancelHandler = () => void;

type Context = {
  requestCancelAddNewSession:
    | ((onCancelled?: AddNewSessionCancelHandler) => void)
    | null;
  setRequestCancelAddNewSession: Dispatch<
    SetStateAction<Context["requestCancelAddNewSession"]>
  >;
};

const CalendarSidebarContext = createContext<Context>({
  requestCancelAddNewSession: null,
  setRequestCancelAddNewSession: () => null,
});

export const CalendarSidebarContextProvider = ({ children }) => {
  const [requestCancelAddNewSession, setRequestCancelAddNewSession] =
    useState<Context["requestCancelAddNewSession"]>(null);

  return (
    <CalendarSidebarContext.Provider
      value={{
        requestCancelAddNewSession,
        setRequestCancelAddNewSession,
      }}
    >
      {children}
    </CalendarSidebarContext.Provider>
  );
};

export const useCalendarSidebarContext = () =>
  useContext(CalendarSidebarContext);
